<template>
  <div>
    <NavBar :pageName="pageName" />

    <!-- 2 panels (left 33% / right 66%) -->
    <div v-if="!grid" class="main-container">
      <div class="left-panel">
        <div class="slot-content-left">
          <slot name="left"> </slot>
        </div>
      </div>
      <div class="right-panel">
        <div class="slot-content-right">
          <slot name="right"></slot>
        </div>
      </div>
    </div>

    <!-- 4 panels (left 30% / right 70%) -->
    <div v-if="grid" class="main-container">
      <div :class="{ 'left-grid-panel': !fullPanel, 'left-grid-panel-full': fullPanel }">
        <div :class="{ 'top-left-slot': !fullPanel, 'top-left-slot-full': fullPanel }">
          <slot name="top-left"> </slot>
        </div>
        <div class="bottom-left-slot">
          <slot name="bottom-left"> </slot>
        </div>
      </div>
      <div class="right-grid-panel">
        <div class="top-right-slot">
          <slot name="top-right"> </slot>
        </div>
        <div class="bottom-right-slot">
          <slot name="bottom-right"> </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import NavBar from "@/newComponents/_Organisms/NavBar";

export default {
  name: "ManagementPage",

  mixins: [
    checkPermissionsMixin,
  ],

  props: {
    pageName: {
      type: String,
      default: "",
    },

    grid: {
      type: Boolean,
      default: false,
    },
    
    fullPanel: {
      type: Boolean,
      default: false,
    },

  },

  components: {
    NavBar,
  },

  data() {
    return {};
  },

  created() {
    if (this.userHasFibercloudPermission("list_list")) {
      this.GET_ALL_LISTS();
    }
  },

  methods: {
    ...mapActions(["GET_ALL_LISTS"])
  }
};
</script>

<style scoped>
.main-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-color: #fafbfc;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

/* 2 panels */
.left-panel {
  margin-top: 50px;
  flex: 1;
  padding: 30px 4px 30px 75px;
  width: 66%;
}

.slot-content-left {
  border-radius: 0.5rem;
  width: 100%;
  height: 100%;
}
.right-panel {
  margin-top: 50px;
  flex: 1;
  padding: 30px 75px 30px 4px;
  max-width: 33%;
}
.slot-content-right {
  border-radius: 0.5rem;
  width: 100%;
  height: 100%;
}

/* 4 panels */
.left-grid-panel {
  margin-top: 50px;
  flex: 1;
  padding: 30px 4px 30px 75px;
  width: 30%;
}

.left-grid-panel-full {
  margin-top: 50px;
  height: 100%;
  flex: 1;
  padding: 30px 4px 30px 75px;
  width: 30%;
}

.right-grid-panel {
  margin-top: 50px;
  flex: 2;
  padding: 30px 75px 30px 4px;
  width: 70%;
}

.left-grid-panel,
.right-grid-panel {
  gap: 8px;
  display: flex;
  flex-direction: column;
}

.top-left-slot,
.bottom-left-slot,
.top-right-slot,
.bottom-right-slot {
  height: calc(50% - 4px);
  border-radius: 8px;
}

.top-left-slot-full{
  height: calc(100% - 49px);
  border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/newComponents/_Organisms/ManagementPage.vue